import React from 'react';
import PropTypes from 'prop-types';
import { Header } from '../Header';
import { Sidebar } from '../Sidebar';
import { Aside, Container, Content, Entry, StyledLayout } from './styled';

export const Layout = ({ children }) => (
  <StyledLayout>
    <Aside>
      <Sidebar />
    </Aside>
    <Container>
      <Header />
      <Content>
        <Entry>{children}</Entry>
      </Content>
    </Container>
  </StyledLayout>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired
};
